
















































































































































































import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Mixins,
} from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import User from "../../../store/entities/user";
import AppConsts from "@/lib/appconst";
import _ from "lodash";
import UserRoleTreeMixin from "./user-roleTree";

@Component
export default class EditUser extends Mixins(AbpBase, UserRoleTreeMixin) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  user: any = {};
  spinShow: boolean = false;
  imageUrl: string = "";
  id: number = 0;
  isUpload: boolean = false;
  departments = [];
  titles = [];
  parentLoading: boolean = false;

  parentData: Array<any> = new Array<any>();
  treeData = [];
  searchParent_OnPress = _.debounce(
    this.searchParents,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  get appRoles() {
    return AppConsts.identityUserAppRoles;
  }
  async searchParents(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.parentLoading = true;
    this.parentData = await this.$store.dispatch({
      type: "user/searchForSelect",
      data: {
        keyWord: keyword,
        clientCode: this.user.clientCode,
      },
    });
    this.parentLoading = false;
  }
  changeManager() {
    if (_.isNil(this.user.parentId) || this.user.parentId <= 0) {
      this.user.manager = null;
    } else {
      var manager = this.parentData.find((i) => i.id === this.user.parentId);
      if (!_.isNil(manager)) {
        this.user.manager.userName = manager.userName;
        this.user.manager.name = manager.name;
      }
    }
  }
  created() {}
  get avatarUrl() {
    return this.imageUrl;
  }
  get roles() {
    var roles = this.$store.state.user.roles;
    return roles;
  }
  save() {
    (this.$refs.userForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.spinShow = true;
        const selectedNotes = (this.$refs[
          "tree"
        ] as any).getCheckedAndIndeterminateNodes();
        var permissionType = this.permissionType;
        const selectedChildrenNodes = _.filter(selectedNotes, function(o) {
          return o.type === permissionType;
        });
        this.user.roleIds = _.map(selectedChildrenNodes, (n) => n.key) || [];
        this.$store
          .dispatch({
            type: "user/update",
            data: this.user,
          })
          .then(() => {
            (this.$refs.userForm as any).resetFields();
            this.$emit("save-success");
            this.$emit("input", false);
          })
          .finally(() => {
            this.spinShow = false;
          });
      }
    });
  }
  cancel() {
    this.user = {};
    this.imageUrl = "";
    this.isUpload = false;
    (this.$refs.userForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.isUpload = false;
      this.imageUrl = "";
      this.user = {};
      var user = Util.extend(true, {}, this.$store.state.user.editUser);
      this.id = user.id;
      this.getDepartments();
      this.getTitles();
      this.getUserInfo();
    }
  }
  getDepartments() {
    this.$store
      .dispatch({
        type: "user/getDepartmentForSelect",
        data: {},
      })
      .then((result) => {
        this.departments = result;
      });
  }
  getTitles() {
    this.$store
      .dispatch({
        type: "user/getTitleForSelect",
        data: {},
      })
      .then((result) => {
        this.titles = result;
      });
  }
  getUserInfo() {
    this.$store
      .dispatch({
        type: "user/get",
        data: { id: this.id },
      })
      .then((result) => {
        this.user = result;
        this.treeData = this.initTree({
          roles: this.roles,
          userRoleIds: this.user.roleIds,
        });
        if (!_.isNil(this.user.avatarUrl) && !_.isEmpty(this.user.avatarUrl)) {
          this.imageUrl = Util.getAppUrlImage(this.user.avatarUrl);
          this.isUpload = true;
        } else {
          this.imageUrl = "";
          this.isUpload = false;
        }
      });
  }
  handleBeforeUpload(file) {
    const fileExt = file.name
      .split(".")
      .pop()
      .toLocaleLowerCase();

    if (
      fileExt === "jpep" ||
      fileExt === "jpg" ||
      fileExt === "png" ||
      fileExt === "gif" ||
      fileExt === "jfif"
    ) {
      let data = new FormData();
      data.append("file", file);

      this.$store.dispatch("user/uploadAvatar", data).then((res) => {
        this.user.avatarUrl = res;
        this.imageUrl = Util.getAppUrlImage(res);
        this.isUpload = true;
      });
    }

    return false;
  }
  handleRemoveAvatar() {
    this.isUpload = false;
    this.imageUrl = "";
    this.user.avatarUrl = "";
  }
  userRule = {
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Name")),
        trigger: "blur",
      },
    ],
    surname: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Surname")),
        trigger: "blur",
      },
    ],
  };
}
